import { useIntl } from 'react-intl';
import { CustomsField } from '../customs-field';
import { QuantityInput } from './quantity-input';

import messages from '../messages';

type CustomsQuantityProps = {
  value?: number;
  onChange: (value: number) => void;
};

export const CustomsQuantity: React.FC<CustomsQuantityProps> = ({ onChange, value = 0 }) => {
  const intl = useIntl();

  const handleChange = (newValue: string | number) => {
    const numericValue = typeof newValue === 'string' ? parseInt(newValue, 10) : newValue;
    onChange(numericValue);
  };

  return (
    <CustomsField label={messages.quantityLabel} required>
      <QuantityInput aria-label={intl.formatMessage(messages.quantityLabel)} onChange={handleChange} value={value} />
    </CustomsField>
  );
};
